import { UNICODE_LATIN_BASIC, UNICODE_LTR_EXTENDED, UNICODE_RTL_BROAD } from '../consts/unicodeRanges';

// Unicode for RTL / LTR characters
const RTL = UNICODE_RTL_BROAD;
const LTR = UNICODE_LATIN_BASIC + UNICODE_LTR_EXTENDED;

// eslint-disable-next-line no-misleading-character-class
const RTL_REGEX = new RegExp('^[^' + LTR + ']*[' + RTL + ']');
// eslint-disable-next-line no-misleading-character-class
const LTR_REGEX = new RegExp('^[^' + RTL + ']*[' + LTR + ']');

/**
 * Detect the base direction of a string by its first strong directional character (the Unicode bidi P2/P3
 * rule). Returns null when the text is empty or has no strong character.
 *
 * Shared between the studio's tiptap TextDirection plugin and the server-side content generators so both
 * compute identical `dir` values from the same Unicode ranges (single source of truth).
 *
 * Source: https://github.com/facebook/lexical/blob/429e3eb5b5a244026fa4776650aabe3c8e17536b/packages/lexical/src/LexicalUtils.ts#L163
 */
export function getTextDirection(text: string): 'ltr' | 'rtl' | null {
  if (text.length === 0) {
    return null;
  }
  if (RTL_REGEX.test(text)) {
    return 'rtl';
  }
  if (LTR_REGEX.test(text)) {
    return 'ltr';
  }
  return null;
}
